@if (showLayout) {
  <div class="app-container">
    <app-sidebar></app-sidebar>
    <div class="main-content">
      <app-header></app-header>
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
